define([
	"dojo/_base/declare",
	"csi/heading/TextController",
	"csi/state/rootStore",
	"./Locale"
], function(declare, TextController, {localStore}, Locale) {

	return declare(TextController, {
		bHold: true,

		toWriter: function() {
			// summary: write operations for new attribute value
			var node = this.getNode();
			var store = this.widget.get("store");
			var w = this.m_writer;
			var b = w.bCannotCache;

			Locale.setResource(
				w,
				store.getResourceAttribute(),
				store.getResourceKeys(node, this.keyContainer),
				this.newValue,
				localStore.editLocale
			);

			w.bCannotCache = b;

			// even though we use a special request to publish changes, we also cache the change locally
			store.put(node);

			// no need to return results of change - this will only work if this is the only controller
			// writing changes in view!
			w.noReturnNodes();
		}
	});
});